import { Controller } from '@hotwired/stimulus';
import Swiper from 'swiper';
import 'swiper/css';
import { Mousewheel, Keyboard, FreeMode, Scrollbar, Navigation } from 'swiper/modules';
import { useMatchMedia } from 'stimulus-use';

export default class extends Controller {
  static targets = ['swiper', 'wrapper', 'slide', 'scrollbar', 'navigation'];
  static values = {
    params: Object,
  };

  initialize() {}

  connect() {
    this.options = {
      modules: [Navigation, FreeMode, Mousewheel, Keyboard],
      direction: 'horizontal',
      ...(typeof this.paramsValue.slidesPerView !== 'undefined' && typeof this.paramsValue.slidesPerView === 'number'
        ? {
            slidesPerView: this.paramsValue.slidesPerView,
          }
        : {
            slidesPerView: 'auto',
          }),
      spaceBetween: this.paramsValue.spaceBetween,
      grabCursor: true,
      keyboard: {
        enabled: true,
      },
      mousewheel: {
        releaseOnEdges: true,
        forceToAxis: true,
      },
      ...(this.paramsValue.freeMode && {
        freeMode: {
          enabled: true,
        },
      }),
      ...(this.paramsValue.autoHeight && {
        autoHeight: true,
      }),
      ...(this.hasNavigationTarget && {
        navigation: {
          nextEl: '.btn-next',
          prevEl: '.btn-prev',
          disabledClass: 'opacity-0',
        },
      }),
    };

    useMatchMedia(this, {
      mediaQueries: {
        mobile: '(max-width: 768px)',
        tablet: '(max-width: 992px)',
      },
    });
    const mobileMediaQuery = window.matchMedia('(max-width: 768px)');
    const tabletMediaQuery = window.matchMedia('(max-width: 992px)');

    // Init All Instances that have no mediaQueries
    if (!this.paramsValue.untilMobile && !this.paramsValue.untilTablet) {
      this.initSlider();
    }
    // Check for Mobile Media Queries
    if (mobileMediaQuery.matches && this.paramsValue.untilMobile) {
      this.initSlider();
    }
    // Check for Tablet Media Queries
    if (tabletMediaQuery.matches && this.paramsValue.untilTablet) {
      this.initSlider();
    }
  }

  isTablet({ name, media, matches, event }) {
    if (matches && this.paramsValue.untilTablet) {
      this.initSlider();
    }
  }
  notTablet({ name, media, matches, event }) {
    if (!matches && this.paramsValue.untilTablet) {
      this.destroySlider(true);
    }
  }

  isMobile({ name, media, matches, event }) {
    if (matches && this.paramsValue.untilMobile) {
      this.initSlider();
    }
  }

  notMobile({ name, media, matches, event }) {
    if (!matches && this.paramsValue.untilMobile) {
      this.destroySlider(true);
    }
  }

  initSlider() {
    this.swiperTarget.classList.add('swiper');
    this.wrapperTarget.classList.add('swiper-wrapper');
    this.navigationTarget.classList.remove('md:hidden');
    this.slideTargets.forEach((item) => {
      item.classList.add('swiper-slide');
    });
    this.swiper = new Swiper(this.swiperTarget, this.options);
  }

  destroySlider(hideNav = false) {
    this.swiper?.destroy();
    this.swiperTarget.classList.remove('swiper');
    this.wrapperTarget.classList.remove('swiper-wrapper');
    if (hideNav) {
      this.navigationTarget.classList.add('md:hidden');
    }
    this.slideTargets.forEach((item) => {
      item.classList.remove('swiper-slide');
    });
  }
}
